import http from '../utils/httpClient';
export type InspectionNotice={id:string;inspection_id:string;received_at?:string;read_at?:string};
type Cursor={before_time:string;before_id:string};
export async function inspectionNotices(inspectionId?:string):Promise<InspectionNotice[]>{
 const records:InspectionNotice[]=[],seen=new Set<string>();let cursor:Cursor|null=null;
 do {
  const params=new URLSearchParams({limit:'100'});
  if(inspectionId)params.set('inspection_id',inspectionId);
  if(cursor){params.set('before_time',cursor.before_time);params.set('before_id',cursor.before_id)}
  const response=await http.get(`/api/v1/hotel/inspection-notifications?${params}`);
  if(!response.ok)throw new Error('Notifications des contrôles indisponibles');
  const data=await response.json();
  for(const item of data.data||[]){if(!seen.has(item.id)){seen.add(item.id);records.push(item)}}
  const next:Cursor|null=data.next_cursor||null;
  if(next&&cursor&&next.before_id===cursor.before_id)throw new Error('Pagination des notifications interrompue');
  cursor=next;
 }while(cursor);
 return records;
}
export async function acknowledgeInspectionNotices(items:InspectionNotice[],read=false){
 const pending=items.filter(item=>read?!item.read_at:!item.received_at);
 for(let offset=0;offset<pending.length;offset+=20){await Promise.all(pending.slice(offset,offset+20).map(async item=>{
  const response=await http.post(`/api/v1/hotel/inspection-notifications/${item.id}/acknowledge`,{read});
  if(!response.ok)throw new Error('Accusé de réception non enregistré');
 }))}
}
